// @flow
import * as React from 'react';
import { PrimaryButton, SecondaryButton, LinkButton } from 'components/Button';
import Box from 'components/Box';
import { H3, BodySmall } from 'components/Text';

const GroupsMapAddPinConfirm = ({
  confirmAddPin,
  confirmCreateGroup,
  cancelAddPin
}: {
  confirmAddPin: () => void,
  confirmCreateGroup: () => void,
  cancelAddPin: () => void
}) => (
  <Box width={['auto', 480]}>
    <H3 textAlign="center">{getText('Add pin here?')}</H3>

    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="space-between"
      mt={[24, 32]}
    >
      <Box width={[1, 'calc(50% - 4px)']}>
        <PrimaryButton
          data-qa-id="days-map-confirm-add-group"
          width={1}
          onClick={confirmCreateGroup}
        >
          {getText('Mutual Aid Group')}
        </PrimaryButton>
      </Box>
      <Box width={[1, 'calc(50% - 4px)']} mt={['8px', 0]}>
        <SecondaryButton
          data-qa-id="days-map-confirm-add-pin"
          width={1}
          onClick={confirmAddPin}
        >
          {getText('Individual Offer')}
        </SecondaryButton>
      </Box>
    </Box>

    <Box display="flex" justifyContent="center" mt={24} mb={12}>
      <LinkButton
        data-qa-id="days-map-cancel-add-pin"
        onClick={cancelAddPin}
        grey
      >
        <BodySmall styleAs="h5">{getText('Cancel')}</BodySmall>
      </LinkButton>
    </Box>
  </Box>
);

export default GroupsMapAddPinConfirm;
